import {
  Layers,
  Palette,
  Settings2,
  Paintbrush,
  SwatchBook,
  Component,
} from 'lucide-react'

const features = [
  {
    icon: Layers,
    title: 'Material wrapper',
    description:
      'Built on top of Material Design with sensible defaults and enhanced customization.',
  },
  {
    icon: SwatchBook,
    title: 'Design tokens at scale',
    description:
      'Comprehensive token system covering colors, spacing, typography, and more.',
  },
  {
    icon: Settings2,
    title: 'Strong customization',
    description:
      'Override any token or component to match your brand identity.',
  },
  {
    icon: Paintbrush,
    title: 'Token-driven theming',
    description:
      'Themes are composed from tokens, making global changes effortless.',
  },
  {
    icon: Palette,
    title: 'Semantic color system',
    description:
      'Colors organized by purpose, not just hue. Primary, surface, error, and more.',
  },
  {
    icon: Component,
    title: '32 reusable components',
    description: 'Production-ready components that follow consistent patterns.',
  },
]

export function FeatureGrid() {
  return (
    <section className="bg-white py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        {/* Section Title */}
        <h2 className="mb-4 text-center font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
          What you get with Garmisch
        </h2>
        <p className="mx-auto mb-16 max-w-2xl text-center text-gray-500 dark:text-white/60">
          Everything you need to build consistent Flutter applications.
        </p>

        {/* Grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group rounded-2xl border border-gray-200 bg-gray-50 p-6 transition-all hover:border-gray-300 hover:bg-white dark:border-white/10 dark:bg-[#111113] dark:hover:border-white/20 dark:hover:bg-[#151517]"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#448AFF]/10 transition-colors group-hover:bg-[#448AFF]/15">
                <feature.icon className="h-6 w-6 text-[#448AFF]" />
              </div>
              <h3 className="mb-2 text-lg font-semibold text-gray-900 dark:text-white">
                {feature.title}
              </h3>
              <p className="text-sm leading-relaxed text-gray-500 dark:text-white/60">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
